import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import PageHeader from "../../page-header";
import CrossSkillingDashboardTabs from "./cross-skilling-dashboard-tabs";

const ManageCrossSkillingDashboard = ({ fullTimeSchedule }: any) => {
	const { t } = useTranslation();

	// GAT-7289 - with Cross Skilling off, this page only carries the Jobs Matrix.
	const showCrossSkilling = useSelector(
		(state: any) => state.user.userData.showCrossSkilling
	);

	return (
		<Box >
			{/* BOEING RELATED CHANGES - Full time scheduler text alteration */}
				{/* <PageHeader
					title={fullTimeSchedule ? "Certification" : "Cross skill your workers"}
					subtitle={
						fullTimeSchedule
							? "Track, add and edit your workers' certifications."
							: "Add or edit new skills to your workers, to mark them as interested."
					}
				/> */}
				<Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            background: "#fff",
                            padding: "24px 24px 0px 24px",
                            borderRadius: "15px 15px 0px 0px",
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: "Roboto",
                                fontSize: "24px",
                                fontWeight: 400,
                                color: "rgba(0,0,0,0.87)",
                            }}
                        >
                            {showCrossSkilling
                                ? t("cross-skilling-dashboard_cross-skilling")
                                : t("jobs-matrix_page-title")}
                        </Typography>
                    </Box>
			<CrossSkillingDashboardTabs />
		</Box>
	);
};

export default ManageCrossSkillingDashboard;
